export const iconsRegular = [
  {
    prefix: "far",
    name: "address-book",
  },
  {
    prefix: "far",
    name: "address-card",
  },
  {
    prefix: "far",
    name: "angry",
  },
  {
    prefix: "far",
    name: "arrow-alt-circle-down",
  },
  {
    prefix: "far",
    name: "arrow-alt-circle-left",
  },
  {
    prefix: "far",
    name: "arrow-alt-circle-right",
  },
  {
    prefix: "far",
    name: "arrow-alt-circle-up",
  },
  {
    prefix: "far",
    name: "bell",
  },
  {
    prefix: "far",
    name: "bell-slash",
  },
  {
    prefix: "far",
    name: "bookmark",
  },
  {
    prefix: "far",
    name: "building",
  },
  {
    prefix: "far",
    name: "calendar",
  },
  {
    prefix: "far",
    name: "calendar-alt",
  },
  {
    prefix: "far",
    name: "calendar-check",
  },
  {
    prefix: "far",
    name: "calendar-minus",
  },
  {
    prefix: "far",
    name: "calendar-plus",
  },
  {
    prefix: "far",
    name: "calendar-times",
  },
  {
    prefix: "far",
    name: "caret-square-down",
  },
  {
    prefix: "far",
    name: "caret-square-left",
  },
  {
    prefix: "far",
    name: "caret-square-right",
  },
  {
    prefix: "far",
    name: "caret-square-up",
  },
  {
    prefix: "far",
    name: "chart-bar",
  },
  {
    prefix: "far",
    name: "check-circle",
  },
  {
    prefix: "far",
    name: "check-square",
  },
  {
    prefix: "far",
    name: "circle",
  },
  {
    prefix: "far",
    name: "clipboard",
  },
  {
    prefix: "far",
    name: "clock",
  },
  {
    prefix: "far",
    name: "clone",
  },
  {
    prefix: "far",
    name: "closed-captioning",
  },
  {
    prefix: "far",
    name: "comment",
  },
  {
    prefix: "far",
    name: "comment-alt",
  },
  {
    prefix: "far",
    name: "comment-dots",
  },
  {
    prefix: "far",
    name: "comments",
  },
  {
    prefix: "far",
    name: "compass",
  },
  {
    prefix: "far",
    name: "copy",
  },
  {
    prefix: "far",
    name: "copyright",
  },
  {
    prefix: "far",
    name: "credit-card",
  },
  {
    prefix: "far",
    name: "dizzy",
  },
  {
    prefix: "far",
    name: "dot-circle",
  },
  {
    prefix: "far",
    name: "edit",
  },
  {
    prefix: "far",
    name: "envelope",
  },
  {
    prefix: "far",
    name: "envelope-open",
  },
  {
    prefix: "far",
    name: "eye",
  },
  {
    prefix: "far",
    name: "eye-slash",
  },
  {
    prefix: "far",
    name: "file",
  },
  {
    prefix: "far",
    name: "file-alt",
  },
  {
    prefix: "far",
    name: "file-archive",
  },
  {
    prefix: "far",
    name: "file-audio",
  },
  {
    prefix: "far",
    name: "file-code",
  },
  {
    prefix: "far",
    name: "file-excel",
  },
  {
    prefix: "far",
    name: "file-image",
  },
  {
    prefix: "far",
    name: "file-pdf",
  },
  {
    prefix: "far",
    name: "file-powerpoint",
  },
  {
    prefix: "far",
    name: "file-video",
  },
  {
    prefix: "far",
    name: "file-word",
  },
  {
    prefix: "far",
    name: "flag",
  },
  {
    prefix: "far",
    name: "flushed",
  },
  {
    prefix: "far",
    name: "folder",
  },
  {
    prefix: "far",
    name: "folder-open",
  },
  {
    prefix: "far",
    name: "frown",
  },
  {
    prefix: "far",
    name: "frown-open",
  },
  {
    prefix: "far",
    name: "futbol",
  },
  {
    prefix: "far",
    name: "gem",
  },
  {
    prefix: "far",
    name: "grimace",
  },
  {
    prefix: "far",
    name: "grin",
  },
  {
    prefix: "far",
    name: "grin-alt",
  },
  {
    prefix: "far",
    name: "grin-beam",
  },
  {
    prefix: "far",
    name: "grin-beam-sweat",
  },
  {
    prefix: "far",
    name: "grin-hearts",
  },
  {
    prefix: "far",
    name: "grin-squint",
  },
  {
    prefix: "far",
    name: "grin-squint-tears",
  },
  {
    prefix: "far",
    name: "grin-stars",
  },
  {
    prefix: "far",
    name: "grin-tears",
  },
  {
    prefix: "far",
    name: "grin-tongue",
  },
  {
    prefix: "far",
    name: "grin-tongue-squint",
  },
  {
    prefix: "far",
    name: "grin-tongue-wink",
  },
  {
    prefix: "far",
    name: "grin-wink",
  },
  {
    prefix: "far",
    name: "hand-lizard",
  },
  {
    prefix: "far",
    name: "hand-paper",
  },
  {
    prefix: "far",
    name: "hand-peace",
  },
  {
    prefix: "far",
    name: "hand-point-down",
  },
  {
    prefix: "far",
    name: "hand-point-left",
  },
  {
    prefix: "far",
    name: "hand-point-right",
  },
  {
    prefix: "far",
    name: "hand-point-up",
  },
  {
    prefix: "far",
    name: "hand-pointer",
  },
  {
    prefix: "far",
    name: "hand-rock",
  },
  {
    prefix: "far",
    name: "hand-scissors",
  },
  {
    prefix: "far",
    name: "hand-spock",
  },
  {
    prefix: "far",
    name: "handshake",
  },
  {
    prefix: "far",
    name: "hdd",
  },
  {
    prefix: "far",
    name: "heart",
  },
  {
    prefix: "far",
    name: "hospital",
  },
  {
    prefix: "far",
    name: "hourglass",
  },
  {
    prefix: "far",
    name: "id-badge",
  },
  {
    prefix: "far",
    name: "id-card",
  },
  {
    prefix: "far",
    name: "image",
  },
  {
    prefix: "far",
    name: "images",
  },
  {
    prefix: "far",
    name: "keyboard",
  },
  {
    prefix: "far",
    name: "kiss",
  },
  {
    prefix: "far",
    name: "kiss-beam",
  },
  {
    prefix: "far",
    name: "kiss-wink-heart",
  },
  {
    prefix: "far",
    name: "laugh",
  },
  {
    prefix: "far",
    name: "laugh-beam",
  },
  {
    prefix: "far",
    name: "laugh-squint",
  },
  {
    prefix: "far",
    name: "laugh-wink",
  },
  {
    prefix: "far",
    name: "lemon",
  },
  {
    prefix: "far",
    name: "life-ring",
  },
  {
    prefix: "far",
    name: "lightbulb",
  },
  {
    prefix: "far",
    name: "list-alt",
  },
  {
    prefix: "far",
    name: "map",
  },
  {
    prefix: "far",
    name: "meh",
  },
  {
    prefix: "far",
    name: "meh-blank",
  },
  {
    prefix: "far",
    name: "meh-rolling-eyes",
  },
  {
    prefix: "far",
    name: "minus-square",
  },
  {
    prefix: "far",
    name: "money-bill-alt",
  },
  {
    prefix: "far",
    name: "moon",
  },
  {
    prefix: "far",
    name: "newspaper",
  },
  {
    prefix: "far",
    name: "object-group",
  },
  {
    prefix: "far",
    name: "object-ungroup",
  },
  {
    prefix: "far",
    name: "paper-plane",
  },
  {
    prefix: "far",
    name: "pause-circle",
  },
  {
    prefix: "far",
    name: "play-circle",
  },
  {
    prefix: "far",
    name: "plus-square",
  },
  {
    prefix: "far",
    name: "question-circle",
  },
  {
    prefix: "far",
    name: "registered",
  },
  {
    prefix: "far",
    name: "sad-cry",
  },
  {
    prefix: "far",
    name: "sad-tear",
  },
  {
    prefix: "far",
    name: "save",
  },
  {
    prefix: "far",
    name: "share-square",
  },
  {
    prefix: "far",
    name: "smile",
  },
  {
    prefix: "far",
    name: "smile-beam",
  },
  {
    prefix: "far",
    name: "smile-wink",
  },
  {
    prefix: "far",
    name: "snowflake",
  },
  {
    prefix: "far",
    name: "square",
  },
  {
    prefix: "far",
    name: "star",
  },
  {
    prefix: "far",
    name: "star-half",
  },
  {
    prefix: "far",
    name: "sticky-note",
  },
  {
    prefix: "far",
    name: "stop-circle",
  },
  {
    prefix: "far",
    name: "sun",
  },
  {
    prefix: "far",
    name: "surprise",
  },
  {
    prefix: "far",
    name: "thumbs-down",
  },
  {
    prefix: "far",
    name: "thumbs-up",
  },
  {
    prefix: "far",
    name: "times-circle",
  },
  {
    prefix: "far",
    name: "tired",
  },
  {
    prefix: "far",
    name: "trash-alt",
  },
  {
    prefix: "far",
    name: "user",
  },
  {
    prefix: "far",
    name: "user-circle",
  },
  {
    prefix: "far",
    name: "window-close",
  },
  {
    prefix: "far",
    name: "window-maximize",
  },
  {
    prefix: "far",
    name: "window-minimize",
  },
  {
    prefix: "far",
    name: "window-restore",
  },
];
